import api from '@/api';

export default {
  namespaced: true,

  state: {
    alerts: [],
    currentAlert: {
      title: null,
      description: null,
      persistent: 0,
    },
  },

  getters: {},

  mutations: {
    SET_ALERTS(state, payload) {
      state.alerts = payload;
    },
    SET_CURRENT_ALERT(state, payload) {
      state.currentAlert = payload;
    },
    RESET_ALERT(state) {
      state.currentAlert = {
        title: null,
        description: null,
        persistent: 0,
      };
    },
  },

  actions: {
    async list({ commit }) {
      let response;

      try {
        response = await api().get('/system/alerts');
        commit('SET_ALERTS', response.data.data.alert);
        return Promise.resolve();
      } catch (err) {
        if (err.response.status === 404 && err.response.data.data.length < 1) {
          commit('SET_ALERTS', []);
          return Promise.resolve([]);
        }
        return Promise.reject(err);
      }
    },
    async getAlert({ commit }, id) {
      let response;

      try {
        response = await api().get(`/system/alert/${id}`);
        commit('SET_CURRENT_ALERT', response.data.data.alert[0]);
        return Promise.resolve();
      } catch (err) {
        console.log({ ...err });
        return Promise.reject(err);
      }
    },

    async saveAlert({ commit }, { payload }) {
      let response;

      try {
        response = await api().post('/system/alert', { alert: payload });
        commit('SET_CURRENT_ALERT', response.data.data.alert);
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    },

    async updateAlert({ commit }, { id, payload }) {
      let response;

      try {
        response = await api().post(`/system/alert/${id}`, { alert: payload });
        commit('SET_CURRENT_ALERT', response.data.data.alert);
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    },

    async deleteAlert(context, id) {
      try {
        await api().delete(`/system/alert/${id}`);
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
